// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1W4qC","clinicsSelect":"TableHeading_clinicsSelect__29Tgv"};